// extracted by mini-css-extract-plugin
module.exports = {"ItemContainer":"newHardwareItem_ItemContainer__3z8n8"};